(
    function (skyward, $, undefined)
    {
        skyward.cachecombobox = skyward.cachecombobox || {};
        skyward.cachecombobox.updateDistrictEntity = function (comboBox)
        {
            skyward.cachecombobox.updateValue(comboBox, "DistrictEntity");
        };

        skyward.cachecombobox.updateSchoolYear = function (comboBox)
        {
            skyward.cachecombobox.updateValue(comboBox, "SchoolYear");
        };

        skyward.cachecombobox.updateFiscalYear = function (comboBox)
        {
            skyward.cachecombobox.updateValue(comboBox, "FiscalYear");
        };

        skyward.cachecombobox.updateSection= function (comboBox) {
            skyward.cachecombobox.updateValue(comboBox, "Section");
        };

        skyward.cachecombobox.updateValue = function (comboBox, className)
        {
            var newValue = comboBox.options[comboBox.selectedIndex].value;
            var url = skyward.global.virtualDir + "Security/Window/Update" + className;
            $.ajax({
                url: url,
                type: "POST",
                data: { newValue: newValue },
                success: function (success)
                {
                    window.location.reload(true);
                }
            });
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);